import { render } from "./MenuCard.vue?vue&type=template&id=2c862f96&scoped=true"
import script from "./MenuCard.vue?vue&type=script&lang=js"
export * from "./MenuCard.vue?vue&type=script&lang=js"

import "./MenuCard.vue?vue&type=style&index=0&id=2c862f96&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c862f96"]])

export default __exports__